export default "__VITE_ASSET__99fEpQnX__"